import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './NavMenuItems.module.css';
import { Dropdown } from 'antd';
import { NavLink } from 'react-router-dom';

const MobileExpandableDropdown = ({ items, onNavCallback, className, isOpen, setIsOpen }) => {
  return (
    <div className={className}>
      {isOpen && (
        <ul className={styles.mobileDropdownList}>
          {items.map((item, index) => (
            <li key={index} className={styles.mobileDropdownItem}>
              {item.link ? (
                item.link.startsWith('http') ? (
                  <a
                    href={item.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={styles.mobileDropdownLink}
                    onClick={onNavCallback}
                  >
                    {item.name}
                  </a>
                ) : (
                  <NavLink
                    to={item.link}
                    className={styles.mobileDropdownLink}
                    onClick={onNavCallback}
                  >
                    {item.name}
                  </NavLink>
                )
              ) : (
                <span className={styles.mobileDropdownText}>{item.name}</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

MobileExpandableDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  onNavCallback: PropTypes.func,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

const industries = [
  { name: 'Aerospace', link: null },
  { name: 'Automotive', link: null },
  { name: 'Construction', link: null },
  { name: 'E-Commerce', link: null },
  { name: 'Education', link: null },
  { name: 'Entertainment', link: null },
  { name: 'General Service and Consulting', link: null },
  { name: 'Healthcare and Fitness', link: null },
  { name: 'Individuals, Trusts, and Estates', link: null },
  { name: 'Insurance', link: 'https://insurance.pfsonline.com/' },
  { name: 'Landscaping and Agriculture', link: null },
  { name: 'Law Firms', link: 'https://law.pfsonline.com/' },
  { name: 'Logistics, Transportation, and Warehousing', link: null },
  { name: 'Manufacturing', link: null },
  { name: 'Marketing and Events', link: null },
  { name: 'Nonprofit', link: 'https://nonprofit.pfsonline.com/' },
  { name: 'Private Equity and Holding Companies', link: null },
  { name: 'Professional Service', link: null },
  { name: 'Real Estate', link: null },
  { name: 'Retail, Restaurant, and Hospitality', link: null },
  { name: 'Technology', link: null },
  { name: 'Wholesale and Distribution', link: null },
];

const linkedIndustries = [
  ...industries.filter((i) => i.link),
  { name: '...& More', link: '/who-we-serve' },
];

const NavMenuItems = ({ ListItemClass = '', ListClass = '', LinkActiveClass = 'active', OnNavCallback = () => {} }) => {
  const [mobileWhoWeServeOpen, setMobileWhoWeServeOpen] = useState(false);

  const whoWeServeMenu = (
    <div className={styles.whoWeServeDropdown}>
      <div className={styles.dropdownContent}>
        <div className={styles.leftSection}>
          <div className={styles.sectionTitle}>INDUSTRIES</div>
        </div>
        <div className={styles.industriesGrid}>
          {linkedIndustries.map((industry, index) => (
            <div key={index} className={styles.industryItem}>
              {industry.link.startsWith('http') ? (
                <a
                  href={industry.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className={styles.industryLink}
                  onClick={OnNavCallback}
                >
                  {industry.name}
                </a>
              ) : (
                <NavLink
                  to={industry.link}
                  className={styles.industryLink}
                  onClick={OnNavCallback}
                >
                  {industry.name}
                </NavLink>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  function SetActive(obj) {
    return `${obj.isActive ? LinkActiveClass : ''}`;
  }
  return (
    <ul
      className={`${styles.NavMenuItems} ${ListClass}`}
      data-testid='NavMenuItems'
    >
      <li className={`${ListItemClass}`}>
        <NavLink className={SetActive} to={'/'} onClick={OnNavCallback}>
          Home
        </NavLink>
      </li>
      <li className={`${ListItemClass}`}>
        <NavLink
          className={SetActive}
          to={'/what-we-do'}
          onClick={OnNavCallback}
        >
          What We Do
        </NavLink>
      </li>
      <li className={`${ListItemClass}`}>
        <NavLink
          className={SetActive}
          to={'/who-we-are'}
          onClick={OnNavCallback}
        >
          Who We Are
        </NavLink>
      </li>
      <li className={`${ListItemClass}`}>
        <Dropdown
          overlay={whoWeServeMenu}
          overlayClassName={styles.whoWeServeDropdownWrapper}
          placement='bottom'
        >
          <span 
            className={styles.menuLink} 
            data-testid='whoWeServeDropdownLink'
            onClick={() => setMobileWhoWeServeOpen(!mobileWhoWeServeOpen)}
          >
            Who We Serve
            <span className={`${styles.mobileChevron} ${mobileWhoWeServeOpen ? styles.chevronOpen : ''}`}>
              ▼
            </span>
          </span>
        </Dropdown>
        <MobileExpandableDropdown
          items={linkedIndustries}
          onNavCallback={OnNavCallback}
          className={styles.mobileExpandableDropdown}
          isOpen={mobileWhoWeServeOpen}
          setIsOpen={setMobileWhoWeServeOpen}
        />
      </li>
      <li className={`${ListItemClass}`}>
        <NavLink
          className={SetActive}
          to={'/articles'}
          onClick={OnNavCallback}
        >
          What We Think
        </NavLink>
      </li>
      <li className={`${ListItemClass}`}>
        <NavLink
          className={SetActive}
          to={'/who-we-trust'}
          onClick={OnNavCallback}
        >
          Who We Trust
        </NavLink>
      </li>
    </ul>
  );
};

NavMenuItems.propTypes = {
  ListItemClass: PropTypes.string,
  ListClass: PropTypes.string,
  LinkActiveClass: PropTypes.string,
  OnNavCallback: PropTypes.func,
};

export default NavMenuItems;
